
import { BrowserRouter } from "react-router-dom"
import { useRoutes } from "react-router-dom"
import routes from "./router/config"
import CookieConsent from './components/feature/CookieConsent'

function AppRoutes() {
  const element = useRoutes(routes)
  return element
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <CookieConsent />
    </BrowserRouter>
  )
}

export default App
